import React from "react";
import markSrc from "@/assets/codex-mark.png";

/**
 * CODEX horizontal logo lockup matching the approved artwork:
 *   [icon mark] | CODEX (Cinzel wide-tracked gold)
 *               — ARCHIVE OF THE UNEXPLAINED —
 *
 * Props:
 *  - iconSize: px height of the icon mark (default 36)
 *  - showDivider: thin vertical hairline between icon and wordmark (default true)
 *  - showSubtitle: subtitle with flanking hairlines (default true)
 *  - subtitleClassName: responsive control (e.g. "hidden lg:flex")
 *  - wordmarkSize: tailwind text size class for CODEX (default "text-[20px]")
 */
export const CodexLockup = ({
  iconSize = 36,
  showDivider = true,
  showSubtitle = true,
  subtitleClassName = "",
  wordmarkSize = "text-[20px]",
  wordmarkImage = false,
  wordmarkImgClassName = "w-[132px]",
  vertical = false,
  className = "",
}) => (
  <div className={`${vertical ? "inline-flex flex-col items-center gap-2.5" : "flex items-center gap-3"} ${className}`}>
    <img
      src={markSrc}
      alt="CODEX emblem"
      style={{ height: iconSize, width: "auto" }}
      className="shrink-0 select-none object-contain"
      draggable={false}
    />
    {showDivider && !vertical && (
      <span aria-hidden className="hidden sm:block h-9 w-px bg-gradient-to-b from-transparent via-gold-light/45 to-transparent" />
    )}
    <div className="flex flex-col items-center leading-none">
      {wordmarkImage ? (
        <img
          src="/images/brand/codex-wordmark-clean.png"
          alt="CODEX"
          draggable={false}
          className={`relative block select-none object-contain ${wordmarkImgClassName}`}
          style={{ height: "auto" }}
        />
      ) : (
        <div
          className={`font-wordmark ${wordmarkSize} leading-none codex-chrome`}
          style={{ letterSpacing: "0.2em", paddingRight: "0.2em" }}
        >
          CODEX
        </div>
      )}
      {showSubtitle && (
        <div className={`mt-1.5 flex items-center justify-center gap-1.5 ${subtitleClassName}`}>
          <span aria-hidden className="h-px w-3 bg-gold-light/40" />
          <span className="font-mono text-[7.5px] uppercase tracking-[0.34em] text-gold-light/70 whitespace-nowrap">
            Archive of the Unexplained
          </span>
          <span aria-hidden className="h-px w-3 bg-gold-light/40" />
        </div>
      )}
    </div>
  </div>
);

export default CodexLockup;
